import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { RequestAccessSettingsAccessRightFiltersComponent } from './access-right-filters/access-right-filters.component';
import { RequestAccessSettingService } from './request-access-setting.service';
import { RequestAccessSettingEditComponent } from './request-access-setting-edit/request-access-setting-edit.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiRequestAccessSettingStates } from '@fi-app/request-access-setting/request-access-setting-states';
import { FiCheckbox2Module } from '@fi-shared/fi-checkbox2/fi-checkbox2.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCardModule } from '@angular/material/card';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        UIRouterModule.forChild(FiRequestAccessSettingStates),
        FiCheckbox2Module,
        FiPageHeaderModule,
        MatCardModule,
        FiErrorMessageModule,
    ],
    declarations: [RequestAccessSettingsAccessRightFiltersComponent, RequestAccessSettingEditComponent],
    exports: [RequestAccessSettingsAccessRightFiltersComponent],
    providers: [RequestAccessSettingService],
})
export class RequestAccessSettingModule {}
